/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ZipCode2SvgDto } from '../../models/zip-code-2-svg-dto';

export interface SetSvgForZipCode$Params {
      body: ZipCode2SvgDto
}

export function setSvgForZipCode(http: HttpClient, rootUrl: string, params: SetSvgForZipCode$Params, context?: HttpContext): Observable<StrictHttpResponse<ZipCode2SvgDto>> {
  const rb = new RequestBuilder(rootUrl, setSvgForZipCode.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ZipCode2SvgDto>;
    })
  );
}

setSvgForZipCode.PATH = '/zipCode2Svg';
